import { useEffect } from 'react';
import { DEFAULT_PAGE_TITLE } from 'src/constants/DisplayConstants';

export const usePageTitle = (title: string) => {
  useEffect(() => {
    document.title =
      title == '' ? DEFAULT_PAGE_TITLE : title + ' - ' + DEFAULT_PAGE_TITLE;
  }, [title]);
};
